import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconCalendar2 = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_calendar_light"
      data-name="UI icon/calendar/light"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        id="Union"
        d="M17,20H3a3,3,0,0,1-3-3V5A3,3,0,0,1,3,2H4V1A1,1,0,0,1,6,1V2h8V1a1,1,0,0,1,2,0V2h1a3,3,0,0,1,3,3V17A3,3,0,0,1,17,20ZM2,10v7a1,1,0,0,0,1,1H17a1,1,0,0,0,1-1V10ZM3,4A1,1,0,0,0,2,5V8H18V5a1,1,0,0,0-1-1H16V5a1,1,0,0,1-2,0V4H6V5A1,1,0,0,1,4,5V4Z"
        transform="translate(2 2)"
        fill={color}
      />
    </svg>
  );
};

export default IconCalendar2;
